import React from "react";
import { motion } from "framer-motion";
import { Eyebrow } from "@/components/primitives";

export function PageHeader({ eyebrow, title, sub, children }) {
  return (
    <header className="relative pt-32 pb-16 md:pt-40 md:pb-20 px-5 sm:px-8 lg:px-12 overflow-hidden qs-aurora">
      <div className="absolute inset-0 bg-[#030305]" aria-hidden="true" />
      <div className="absolute inset-0 qs-grid qs-grid-fade opacity-40 pointer-events-none" aria-hidden="true" />
      <div className="absolute -top-32 right-0 h-96 w-96 rounded-full bg-[#0E9E90]/10 blur-3xl pointer-events-none qs-float" aria-hidden="true" />
      <div className="absolute -top-24 left-1/4 h-72 w-72 rounded-full bg-[#14B8A6]/[0.06] blur-3xl pointer-events-none" aria-hidden="true" />
      {/* animated top accent line */}
      <motion.div
        initial={{ scaleX: 0 }} animate={{ scaleX: 1 }} transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="absolute top-0 left-0 right-0 h-px origin-left bg-gradient-to-r from-transparent via-[#0E9E90]/60 to-transparent"
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-7xl">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          {eyebrow && <Eyebrow className="mb-5">{eyebrow}</Eyebrow>}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white leading-[1.03] max-w-4xl tracking-tight">{title}</h1>
          {sub && <p className="mt-6 text-base md:text-lg text-[#94A3B8] max-w-2xl leading-relaxed">{sub}</p>}
          {children && <div className="mt-8">{children}</div>}
        </motion.div>
      </div>
    </header>
  );
}
